/** @typedef {import('vue-router').RouteLocationNormalizedLoaded} Route */

export const NOINDEX_FOLLOW = 'noindex, follow'

/**
 * @param {Route | null | undefined} route
 * @returns {string | null}
 */
export function resolveRouteRobots (route) {
  if (!route) {
    return null
  }

  if (route.meta.robots) {
    return String(route.meta.robots)
  }

  if (route.meta.requiresAuth || route.meta.requiresAdmin) {
    return NOINDEX_FOLLOW
  }

  if (route.name === 'FreeMealPlan') {
    const keys = Object.keys(route.query || {}).filter((key) => key !== 'lang')
    const hasExtraQuery = keys.some((key) => {
      const value = route.query[key]
      if (value == null || value === '') {
        return false
      }
      if (Array.isArray(value)) {
        return value.some((v) => v != null && String(v) !== '')
      }
      return true
    })
    if (hasExtraQuery) {
      return NOINDEX_FOLLOW
    }
  }

  return null
}
